<template>
    <div class="list-container">
        <div  class="list-type" v-for="version in tab.groups" :key="version.marjorVersion">
            <div class="headline">{{ version.headline }}</div>
            <div class="subtitle-1" v-for="subtitle in version.subtitles" :key="subtitle.text">
                <a
                    :href="subtitle.url"
                    class="doc-link"
                >
                    <span>{{subtitle.text}}</span>
                </a>
            </div>
            <div class="cards">
                <template v-for="entry in version.entries">
                    <LiveEntry
                        v-if="entry.type !== 'Documenation'"
                        :key="entry.title"
                        :title="entry.title"
                        :url="entry.url"
                        :nightly="entry.nightly"
                        :updatedOn="entry.updatedOn"
                        :version="entry.version"
                        :noShareLink="entry.noShareLink"
                    >
                        <template v-slot:logo>
                            <img v-if="entry.logo" :src="entry.logo"/>
                        </template>
                    </LiveEntry>
                    <DocumentationEntry 
                        v-if="entry.type === 'Documenation'"
                        :key="entry.title"
                        :title="entry.title"
                        :url="entry.url"
                    >
                        <img v-if="entry.logo" slot="logo" :src="entry.logo" height="24px">
                    </DocumentationEntry>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import LiveEntry from '@/components/LiveEntry';
import DocumentationEntry from '@/components/DocumentationEntry'


export default {
    name: 'TabView',
    props: {
        tab: Object,
    },
    components: {
        LiveEntry,
        DocumentationEntry,
    },
}
</script>

<style scoped>
.list-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.headline,
.subtitle-1 {
    text-align: center;
}

.list-type {
    margin-bottom: 16px;
}

.cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
}

.cards > * {
    margin: 8px;
}
</style>
